import { Form, Select, Tag } from "antd";
import { debounce } from "lodash";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


interface SelectEnrichmentListProps {
  errors: any;
  value: string;
  isCampaignExist: boolean;
  showLabel?: boolean;
  styles?: React.CSSProperties
  onChange: (value: string) => void;
  loadMoreEnrichmentLists: (params: any) => void;
}

export const SelectEnrichmentList = ({ errors, value, onChange, loadMoreEnrichmentLists, isCampaignExist, showLabel = true, styles }: SelectEnrichmentListProps) => {
  const { leadLists, leadListsLoading, leadListsMetaData: { has_next } } = useSelector((state: any) => state.leadEnrichment);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (!isCampaignExist) {
      loadMoreEnrichmentLists({
        page: 1,
      });
      setCurrentPage(1);
    } else {
      loadMoreEnrichmentLists({
        id: value,
      });
    }
  }, []);

  const onSearch = debounce((value: string) => {
    setSearchTerm(value);
    setCurrentPage(1);
    loadMoreEnrichmentLists({
      page: 1,
      search: value,
    });
  }, 1000);

  const handlePopupScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { target } = e;
    const scrollElement = target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && has_next && !leadListsLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      loadMoreEnrichmentLists({
        page: nextPage,
        search: searchTerm,
      });
    }
  };

  const handleChange = (value: string) => {
    onChange(value);
  };

  const options = leadLists.map((list: any) => {
    const isMissingLinkedinUrl = !list?.linkedin_url_column_name;
    return {
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{list.title}</span>
          {isMissingLinkedinUrl && (
            <Tag color="red" style={{ marginLeft: 8 }}>
              Linkedin Url not configured
            </Tag>
          )}
        </div>
      ),
      value: list.id,
      disabled: isMissingLinkedinUrl,
    };
  });

  return (
    <Form.Item name="enrichment_id"
      style={styles}
      {...(showLabel && { validateStatus: errors.enrichment_id ? 'error' : '', help: errors.enrichment_id ? errors.enrichment_id?.toString() : '', label: 'Enrichment List*:' })}
    >
      <Select
        placeholder="Select an enrichment list"
        disabled={isCampaignExist}
        defaultValue={value}
        value={value}
        onChange={handleChange}
        optionLabelProp="label"
        // showSearch
        // onSearch={onSearch}
        loading={leadListsLoading}
        onPopupScroll={handlePopupScroll}
        options={options}
      />
    </Form.Item>
  )
};

